import { Buffer } from 'buffer';
if (typeof window !== 'undefined') {
  var _window$process;
  if (!window.Buffer) {
    window.Buffer = Buffer;
  }
  if (!window.global) {
    window.global = window;
  }
  if (!window.process) {
    window.process = {};
  }
  if (!((_window$process = window.process) !== null && _window$process !== void 0 && _window$process.env)) {
    window.process = {
      env: {}
    };
  }
}
//# sourceMappingURL=index.js.map